import React, { Component } from 'react';
import { userActions } from '../acciones/userActions';
import { connect } from 'react-redux';
import {Panel} from 'primereact/components/panel/Panel';
import './sistemas.css';
import { withRouter } from 'react-router-dom';
import Layout from 'react-comun-seps/lib/components/Layout';
import { MenuSistema } from '../componentes/MenuSistema';
import MensajeAlertaInline from 'react-comun-seps/lib/components/MensajeAlertaInline';

var I18n = require('react-redux-i18n').I18n;

class SistemasContainer extends Component {
    constructor(props) {
        super(props);
        this.onClickSistema = this.onClickSistema.bind(this);
    }

    componentDidMount(){
        this.updateSistemas();
        document.body.classList.add('body-sistemas');
    }

    componentWillUnmount(){
        document.body.classList.remove('body-sistemas');
    }

    updateSistemas(){
        const { dispatch } = this.props;
        dispatch(userActions.getSistemas());
    }

    onClickSistema(e, sistema){
        const { dispatch } = this.props;
        dispatch(userActions.seleccionaSistema(sistema));
        e.preventDefault();
    }

    renderSistemas(sistemas){
        return <div className="row justify-content-md-center" id="rowsistems" >
            {sistemas.map(sistema => 
                <MenuSistema 
                    key={sistema.codSistema}
                    sistema={sistema} 
                    onClickSistema={this.onClickSistema} 
                />)
            }
        </div>
    }

    mostrarBody(sistemas, alert){
        if(sistemas){
            return (                        
            <Panel  className="panelBase" header={<span><span>{I18n.t('app.seleccion_sistema')}</span></span>} >
                    {this.renderSistemas(sistemas)}
            </Panel>
            );
        }else if(alert && alert.detalle){
            return (<div className="row justify-content-md-center"><MensajeAlertaInline tipoMensaje={alert.tipoMensaje} detalle={alert.detalle}/></div>);
        }
    }
    
    render(){
        const { sistemas, alert } = this.props;
        let cargando = typeof sistemas === "undefined" && Object.getOwnPropertyNames(alert).length===0;

        return (
            <div className= "layout-main-sistemas">
               {!cargando && <Layout staticMenuDesktopInactive={true} activarMenuPrincipal={false} body={
                   <div className="dashboard global-sales ui-panel-content"> 
                    {this.mostrarBody(sistemas,alert)}
                    </div>
               }/> }
               {cargando && <div className="splash-screen"><div className="splash-loader"></div></div>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { authentication, alert } = state;
    const { sistemas, user } = authentication;
    return {
        sistemas, user, alert
    };
}

const connectedSistemasContainer = withRouter(connect(mapStateToProps)(SistemasContainer));
export { connectedSistemasContainer as SistemasContainer };